// extracted by mini-css-extract-plugin
module.exports = {"mobileMenuSection":"MobileMenuSection_mobileMenuSection__1f1Mu","trailingMenu":"MobileMenuSection_trailingMenu__lBFAO","personalMenu":"MobileMenuSection_personalMenu__pDSdW"};